import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";

import { FinanceReceivableListFeaturePage } from "..";

/** 应收清单页面：选中的团放在地址的 orderId 上，可以直接打开某个团。 */
export function FinanceReceivableListPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectOrder = useCallback((orderId: string) => setSearchParams({ orderId }), [setSearchParams]);
  return <FinanceReceivableListFeaturePage orderId={searchParams.get("orderId")} onSelectOrder={selectOrder} />;
}
